<script>
  export let content;
  export let link;

  let clazz;
  export { clazz as class };
</script>

<p data-testid="eyebrow" class={`text-center text-size-16 ${clazz}`}>
  {#if link}
    <a class="font-extrabold generic-focus focus:text-cyan-700" data-sveltekit-reload href={link}
      >{content}</a
    >
  {:else}
    <span class="font-extrabold text-neutral-600">{content}</span>
  {/if}
</p>
